module.exports = __webpack_public_path__ + "img/50b5a2d.svg";